<script>


 
import { loginWithEmailPassword, loginWithGoogle } from '../../Services/firebase';
import { user } from '../../store';
     
 

    let email = "";
    let password = "";


   
    
    const handleLoginForm = async () => {
        console.log("Attempting");
       await loginWithEmailPassword(email, password)
 
    };

    
 
</script>

<div class="section_wrapper">
   <div class="s s33">
        <div class="s s100 box ">
             <!--
            <div class="content_area">
                <form>
                    <input
                        type="email"
                        name="email"
                        bind:value={email}
                        placeholder="Email" />

                    <input
                        type="password"
                        name="password"
                        bind:value={password}
                        placeholder="Password" />
                </form>
                
            </div>
            -->
            <div class="content_area">
               <!-- <div class="s">
                    <a  class="linkbox green" on:click={handleLoginForm}>Login</a>
                </div>
                -->
                {#if $user.loggedIn}
                    <p>You are logged in</p>
                {:else}
                <div class="s">
                    <a class="linkbox green" type="button" on:click|preventDefault={loginWithGoogle}>
                        Sign In with Google
                    </a>
                </div>
                <p>
                    You need to use your base2 email account. 
                </p>
                {/if}
            </div>
            
        </div>
        
    </div>
</div>
